import React from 'react'
import { connect } from 'react-redux'
import PreferencesModal from '../../components/preferences-modal'
import { closePreferences, showCart } from '../../actions/settings'
import { closeModal as closeDiamondModal, openDetailsModal } from '../../actions/search'
import { addDiamondsToCart } from '../../actions/cart'
import DiamondModal from '../../components/diamond-modal'
import JewelryModal from '../../components/jewelry-modal'
import { closeModal as closeJewelryModal } from '../../actions/jewelry-search'
import { getJewelryModalPrice } from '../../selectors/jewelry-search'
import {
  modalRowIsAddable,
  getDiamondModalPrice
} from '../../selectors/search'

const mapStateToProps = (state) => {
  return {
    preferencesModalOpen: state.settings.preferencesModalOpen,
    jewelryModalPrice: getJewelryModalPrice(state),
    jewelryModalData: state.jewelrySearch.modalRow,
    jewelryModalOpen: state.jewelrySearch.modalOpen,
    modalRowIsAddable: modalRowIsAddable(state),
    diamondModalPrice: getDiamondModalPrice(state),
    diamondModalData: state.diamondSearch.modalRow,
    diamondModalRowIndex: state.diamondSearch.modalRowIndex,
    diamondResultSet: state.diamondSearch.results,
    diamondDetailsModalOpen: state.diamondSearch.detailsModalOpen
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    closePreferences: () => { dispatch(closePreferences()) },
    closeJewelryModal: () => { dispatch(closeJewelryModal()) },
    closeDiamondModal: () => { dispatch(closeDiamondModal()) },
    addDiamondClicked: (diamond) => {
      dispatch(addDiamondsToCart([diamond]))
      dispatch(showCart())
    },
    onClickPrevious: (resultSet, currentIndex) => {
      // if the current index is 0 then do nothing
      if (resultSet.length === 0 || currentIndex === 0) {
        return
      }
      // otherwise fetch the record with index as currentIndex - 1 from diamondResultSet
      dispatch(openDetailsModal(resultSet[currentIndex - 1], currentIndex - 1))
    },
    onClickNext: (resultSet, currentIndex) => {
      // if the current index the last element then do nothing
      if (resultSet.length === 0 || currentIndex === resultSet.length - 1) {
        return
      }
      // otherwise fetch the record with index as currentIndex + 1 for diamondResultSet
      dispatch(openDetailsModal(resultSet[currentIndex + 1], currentIndex + 1))
    }
  }
}

const Modals = (props) => {
  return (
    <div>
      <PreferencesModal isOpen={props.preferencesModalOpen} onRequestClose={props.closePreferences} />
      {props.jewelryModalData && <JewelryModal
        price={props.jewelryModalPrice}
        modalRow={props.jewelryModalData}
        onRequestClose={props.closeJewelryModal}
        isOpen={props.jewelryModalOpen}
      />}
      {props.diamondModalData ? <DiamondModal
        price={props.diamondModalPrice}
        modalRow={props.diamondModalData}
        onRequestClose={props.closeDiamondModal}
        isOpen={props.diamondDetailsModalOpen}
        addDiamondClicked={() => props.addDiamondClicked(props.diamondModalData)}
        onClickPrevious={() => props.onClickPrevious(props.diamondResultSet, props.diamondModalRowIndex)}
        onClickNext={() => props.onClickNext(props.diamondResultSet, props.diamondModalRowIndex)}
        diamondResultSetLength={props.diamondResultSet.length}
        diamondModalRowIndex={props.diamondModalRowIndex}
        addable={props.modalRowIsAddable}
      /> : ''}
    </div>
  )
}

export default connect(mapStateToProps, mapDispatchToProps)(Modals)



// WEBPACK FOOTER //
// ./src/containers/modals/index.js